<template>
  <div class="page-content grade-class-student">
    <div class="student-list">
      <div class="class-info">
        <div class="class-title">
          <span class="back" @click="back"> ← </span>
          <a-divider type="vertical" />
          <span>{{ classInfo.name }}</span>
        </div>
        <!-- <a-button :disabled="submitDisabled" @click="confirmSubmitGrade">
          {{ $t('handle.submit') }}
        </a-button> -->
      </div>

      <!-- 表格 -->
      <a-table
        size="middle"
        :rowKey="(record) => record.id"
        :loading="studentTableLoading"
        :dataSource="studentDataSource"
        :pagination="false"
        :rowClassName="
          (record) => (studentId === record.id ? 'selected-row' : '')
        "
        :customRow="
          (record) => {
            return {
              style: {
                cursor: 'pointer',
              },
              on: {
                click: () => {
                  if (studentId === record.id) {
                    return
                  }
                  studentInfo = record
                  studentId = record.id
                },
              },
            }
          }
        "
      >
        <a-table-column
          rowClassName="subjectTitle"
          :title="$t('public.studentId')"
          dataIndex="studentNo"
          :sorter="sorterStudentNo"
        ></a-table-column>

        <a-table-column
          :title="$t('public.name')"
          dataIndex="name"
          :sorter="sorterName"
        ></a-table-column>

        <a-table-column
          :title="$t('public.englishName')"
          dataIndex="englishName"
          :sorter="sorterEnglishName"
        >
          <template slot-scope="englishName, record">
            {{ record.surname }} {{ record.givenName }} ({{
              record.englishName
            }})
          </template>
        </a-table-column>
      </a-table>
    </div>

    <div class="student-grade" v-if="!!studentId">
      <div class="search-wrap">
        <div class="grade-title">
          {{ studentInfo.name }} {{ studentInfo.surname }}
          {{ studentInfo.givenName }} ({{ studentInfo.englishName }})
        </div>
        <div class="search-options-wrap">
          <div class="option-item">
            <div class="option-title">{{ $t('public.academicYear') }}</div>
            <a-select
              showSearch
              v-model="academic"
              style="width: 100%"
              :placeholder="$t('public.academicYear')"
              :filterOption="filterOption"
              :dropdownMatchSelectWidth="false"
            >
              <a-select-option
                v-for="(item, index) in academicYearList"
                :key="index"
                :value="item"
              >
                {{ item }}
              </a-select-option>
            </a-select>
          </div>

          <div class="option-item">
            <div class="option-title">{{ $t('week.semester') }}</div>
            <a-select
              showSearch
              v-model="exam"
              style="width: 100%"
              :placeholder="$t('week.semester')"
              :filterOption="filterOption"
              :dropdownMatchSelectWidth="false"
            >
              <a-select-option
                v-for="(item, index) in semesterList"
                :key="index"
                :value="item.value"
              >
                {{ item.label }}
              </a-select-option>
            </a-select>
          </div>
        </div>
      </div>

      <!-- <div class="cover-header"></div> -->
      <div class="cover-content">
        <div class="serContent">
          <div class="table-title student-name">
            {{ subjectName }}
          </div>
          <div class="title" style="line-height: 0; height: 40px">
            Average Score
          </div>
          <!-- 表格 -->
          <a-table
            size="middle"
            :dataSource="averageData"
            :rowKey="(record) => record.id"
            :loading="tableLoading"
            :pagination="false"
          >
            <a-table-column
              :title="$t('public.attendance')"
              dataIndex="attendance"
            ></a-table-column>

            <a-table-column
              :title="$t('public.assignment')"
              dataIndex="assignment"
            ></a-table-column>
            <a-table-column
              :title="$t('public.participation')"
              dataIndex="participation"
            >
            </a-table-column>

            <a-table-column
              :title="$t('public.quiz')"
              dataIndex="quiz"
            ></a-table-column>
          </a-table>
          <div class="title">Basic</div>
          <!-- 表格 -->
          <a-table
            :dataSource="basicData"
            size="middle"
            :rowKey="(record) => record.id"
            :loading="tableLoading"
            :pagination="false"
          >
            <a-table-column
              :title="$t('public.week')"
              dataIndex="week"
            ></a-table-column>

            <a-table-column
              :title="$t('public.attendance')"
              dataIndex="attendance"
            ></a-table-column>

            <a-table-column
              :title="$t('public.assignment')"
              dataIndex="assignments"
            >
            </a-table-column>
            <a-table-column
              :title="$t('public.participation')"
              dataIndex="participation"
            >
            </a-table-column>
            <a-table-column
              :title="$t('public.comments')"
              dataIndex="comment"
              :ellipsis="true"
            ></a-table-column>
          </a-table>
          <div class="title">Quiz</div>
          <!-- 表格 -->
          <a-table
            size="middle"
            :dataSource="quizData"
            :rowKey="(record) => record.id"
            :loading="tableLoading"
            :pagination="false"
          >
            <a-table-column
              :width="180"
              :title="$t('public.quizName')"
              dataIndex="name"
            ></a-table-column>

            <a-table-column
              :width="180"
              :title="$t('public.score')"
              dataIndex="score"
            ></a-table-column>
          </a-table>
        </div>
        <div class="serContent">
          <a-table
            size="middle"
            :rowKey="(record) => record.id"
            :loading="studentTableLoading"
            :dataSource="subjectData"
            :pagination="false"
            :rowClassName="
              (record) => (subjectId === record.id ? 'selected-row' : '')
            "
            :customRow="
              (record) => {
                return {
                  style: {
                    cursor: 'pointer',
                  },
                  on: {
                    click: () => {
                      if (subjectId === record.id) {
                        return
                      }
                      subjectId = record.id
                      subjectName = record.name
                    },
                  },
                }
              }
            "
          >
            <a-table-column
              :title="$t('public.subject')"
              dataIndex="name"
            ></a-table-column>
          </a-table>
        </div>
      </div>
    </div>

    <a-modal
      :title="$t('public.edit', { content: $t('public.grades_lower') })"
      v-model="modalVisible"
      :confirmLoading="modalLoading"
      :afterClose="afterClose"
      @ok="ok"
    >
      <a-form :form="form">
        <a-form-item
          :label="$t('public.score')"
          :labelCol="formItemLayout.labelCol"
          :wrapperCol="formItemLayout.wrapperCol"
        >
          <a-input-number
            :placeholder="$t('public.score_lower')"
            v-decorator="[
              'score',
              {
                rules: [
                  {
                    required: true,
                    message: $t('public.pleaseFill', {
                      content: $t('public.score_lower'),
                    }),
                  },
                ],
              },
            ]"
          />
        </a-form-item>

        <a-form-item
          :label="$t('public.comments')"
          :extra="`${
            form.getFieldValue('comments')
              ? form.getFieldValue('comments').length
              : '0'
          }/1000`"
          :labelCol="formItemLayout.labelCol"
          :wrapperCol="formItemLayout.wrapperCol"
        >
          <a-textarea
            maxLength="1000"
            :autosize="{ minRows: 3, maxRows: 5 }"
            :placeholder="$t('public.comments')"
            v-decorator="[
              'comments',
              {
                rules: [
                  {
                    required: true,
                    message: $t('public.pleaseFill', {
                      content: $t('public.comments_lower'),
                    }),
                  },
                ],
              },
            ]"
          >
          </a-textarea>
        </a-form-item>

        <!-- <a-form-item
          v-if="gradeStatus"
          :label="$t('report.verificationCode')"
          :labelCol="formItemLayout.labelCol"
          :wrapperCol="{ span: 10 }"
        >
          <a-input-search
            :placeholder="$t('report.verificationCode')"
            v-decorator="[
              'verificationCode',
              {
                rules: [
                  {
                    required: true,
                    message: $t('public.pleaseFill', {
                      content: $t('report.verificationCode_lower')
                    })
                  }
                ]
              }
            ]"
            @search="getMailCode"
          >
            <a-button :disabled="haveCode" type="primary" slot="enterButton">
              {{ haveCode ? codeTime : $t('handle.send') }}
            </a-button>
          </a-input-search>
        </a-form-item> -->

        <a-alert
          v-if="gradeStatus"
          :message="$t('report.reeditTip')"
          type="warning"
        />
      </a-form>
    </a-modal>

    <a-modal
      :title="
        $t('public.edit', { content: $t('public.classAdvisorFeedback_lower') })
      "
      v-model="feedbackModalVisible"
      :confirmLoading="feedbackModalLoading"
      :afterClose="feedbackAfterClose"
      @ok="feedbackOk"
    >
      <a-form
        :form="feedbackForm"
        :labelCol="{ span: 3 }"
        :wrapperCol="{ span: 20 }"
      >
        <a-form-item
          :label="$t('public.comments')"
          :extra="`${
            feedbackForm.getFieldValue('comments')
              ? feedbackForm.getFieldValue('comments').length
              : '0'
          }/1000`"
        >
          <a-textarea
            maxLength="1000"
            :autosize="{ minRows: 3, maxRows: 5 }"
            :placeholder="$t('public.comments')"
            v-decorator="[
              'comments',
              {
                rules: [
                  {
                    required: true,
                    message: $t('public.pleaseFill', {
                      content: $t('public.comments_lower'),
                    }),
                  },
                ],
              },
            ]"
          >
          </a-textarea>
        </a-form-item>

        <a-alert
          v-if="gradeStatus"
          :message="$t('report.reeditTip')"
          type="warning"
        />
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      campusId: localStorage.getItem('campusId'),
      classId: this.$route.query.classId,
      classInfo: {},
      submitDisabled: true,
      // 学生
      studentTableLoading: false,
      studentDataSource: [],

      studentInfo: {},
      studentId: '',
      // 学年
      academic: undefined,
      // 考试
      exam: undefined,
      examInfo: {},
      //课程id
      subjectId: '',
      subjectName: '',
      // 课程
      tableLoading: false,
      dataSource: [],

      modalVisible: false,
      modalLoading: false,
      form: this.$form.createForm(this),
      formItemLayout: {
        labelCol: { span: 3 },
        wrapperCol: { span: 20 },
      },
      subjectData: [],
      gradeId: '',
      courseId: '',
      gradeStatus: false,

      // CODE_TIME: 60,
      // codeTime: 60,
      // haveCode: false

      feedbackTableLoading: false,
      feedbackDataSource: [],

      // 编辑反馈
      feedbackModalVisible: false,
      feedbackModalLoading: false,
      feedbackForm: this.$form.createForm(this),
      feedbackId: '',
      averageData: [],
      basicData: [],
      quizData: [],
    }
  },

  computed: {
    ...mapGetters([
      'handleRightsList',
      'userInfo',
      'userId',
      'academicYearList',
      'semesterList',
    ]),
  },

  watch: {
    academic() {
      this.getDataSource()
      this.getFeedback()
      this.getStudentDataSource()
      let data = {
        studentId: this.studentId,
        academic: this.academic,
        semester: this.exam,
      }
      this.StudentSubjectData(data)
    },

    exam(val) {
      for (const item of this.semesterList) {
        if (item.value === val) {
          this.examInfo = item
        }
      }
      this.getDataSource()
      this.getFeedback()
      this.getStudentDataSource()
      let data = {
        studentId: this.studentId,
        academic: this.academic,
        semester: this.exam,
      }
      this.StudentSubjectData(data)
    },

    studentId() {
      this.getDataSource()
      this.getFeedback()
      let data = {
        studentId: this.studentId,
        academic: this.academic,
        semester: this.exam,
      }
      this.StudentSubjectData(data)
    },
    subjectId() {
      let gradeData = {
        studentId: this.studentId,
        courseId: this.subjectId,
        academic: this.academic,
        semester: this.exam,
      }
      this.getGradeData(gradeData)
    },
  },

  created() {
    this.getClassesDetail()
    this.selectYearSemester()
  },

  methods: {
    // 搜索选项
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },

    // 班级详情
    getClassesDetail() {
      this.$http(this.$api.GETCLASSESDETAIL, {
        id: this.classId,
      }).then((r) => {
        this.classInfo = r.data
      })
    },

    // 默认学年学期
    selectYearSemester() {
      const nowTime = new Date()
      const year = nowTime.getFullYear()
      const month = nowTime.getMonth() + 1

      if (month > 8) {
        for (const item of this.academicYearList) {
          if (item.indexOf(year) === 0) {
            this.academic = item
          }
        }
      } else {
        for (const item of this.academicYearList) {
          if (item.indexOf(year - 1) === 0) {
            this.academic = item
          }
        }
      }

      // 默认考试
      if (month >= 9) {
        this.exam = this.semesterList[0].value
      } else if (month >= 6) {
        this.exam = this.semesterList[1].value
      } else if (month >= 3) {
        this.exam = this.semesterList[1].value
      } else {
        this.exam = this.semesterList[0].value
      }
    },

    // 班级里学生
    getStudentDataSource() {
      this.studentTableLoading = true
      this.$http(this.$api.GETLISTBYCLASSID, {
        classId: this.classId,
        academic: this.academic,
        term: this.exam,
      }).then((r) => {
        // console.log(r)
        this.studentDataSource = r.data || []
        this.studentTableLoading = false
        if (!this.studentId && this.studentDataSource.length > 0) {
          this.studentInfo = this.studentDataSource[0]
          this.studentId = this.studentDataSource[0].id
          let data = {
            studentId: this.studentId,
            academic: this.academic,
            semester: this.exam,
          }
          this.StudentSubjectData(data)
        }
      })
    },

    // 提交状态
    checkSubmitStatus() {
      this.$http(this.$api.CHECKSUBMITSTATUS, {
        campusId: this.campusId,
        classId: this.classId,
        academic: this.academic,
        term: this.exam,
        userId: this.userId,
      }).then((r) => {
        if (r.data === 0) {
          this.submitDisabled = false
        } else {
          this.submitDisabled = true
        }
      })
    },

    back() {
      this.$router.back()
    },

    // 提交班级成绩
    // confirmSubmitGrade() {
    //   this.$confirm({
    //     title: this.$t('handle.submit'),
    //     content: this.$t('report.submitGradeTip'),
    //     onOk: () => {
    //       this.submitGrade()
    //     },
    //     onCancel() {}
    //   })
    // },

    submitGrade() {
      this.submitDisabled = true
      this.$http(this.$api.SUBMITGRADE, {
        campusId: this.campusId, // 学习中心ID
        classId: this.classId,
        academic: this.academic,
        term: this.exam,
        userId: this.userId,
      }).then(() => {
        this.checkSubmitStatus()
        this.getDataSource()
        this.$message.success(this.$t('public.saveSuccess'))
      })
    },

    // 学生科目成绩
    getDataSource() {
      if (this.academic && this.exam && this.studentId) {
        this.tableLoading = true
        this.$http(this.$api.GETCOURSERESULTSBYSTUDENTID, {
          campusId: this.campusId, // 学习中心ID
          classId: this.classId,
          academic: this.academic,
          term: this.exam,
          studentId: this.studentId,
          userId: this.userId,
        }).then((r) => {
          this.checkSubmitStatus()
          this.dataSource = r.data.map((item) => {
            if (item.grade) {
              return {
                ...item,
                gradeId: item.grade.id,
                gradeStatus: item.grade.gradeStatus,
                recordStatus: item.grade.recordStatus,
                score: item.grade.score,
                comments: item.grade.comments,
              }
            } else {
              return {
                ...item,
                gradeStatus: 0,
                recordStatus: 0,
              }
            }
          })
          this.tableLoading = false
        })
      }
    },

    editItem(record) {
      this.gradeId = record.gradeId
      this.courseId = record.id
      this.gradeStatus =
        record.gradeStatus === 1 ||
        record.gradeStatus === 2 ||
        record.gradeStatus === 4
      this.modalVisible = true
      let data = {
        studentId: this.studentId,
        academic: this.academic,
        semester: this.exam,
      }
      this.StudentSubjectData(data)
      this.$nextTick().then(() => {
        this.form.setFieldsValue({
          score: record.score,
          comments: record.comments,
        })
      })
    },

    // getMailCode() {
    //   this.haveCode = true
    //   this.codeTime = this.CODE_TIME
    //   this.setCodeTime()
    //   this.$http(this.$api.SENDEMAILCODE, {
    //     userId: this.userId,
    //     gradeId: this.gradeId
    //   }).then(() => {
    //     this.$message.success(this.$t('public.sendSuccess'))
    //   })
    // },

    // 验证码时间
    // setCodeTime() {
    //   if (this.codeTime === 0) {
    //     this.haveCode = false
    //     return
    //   }

    //   setTimeout(() => {
    //     this.codeTime--
    //     this.setCodeTime()
    //   }, 1000)
    // },

    // 提交
    ok() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.handleSave(values)
        }
      })
    },

    handleSave(values) {
      this.modalLoading = true
      const editApi = this.gradeStatus
        ? this.$api.REEDITGRADE
        : this.$api.UPDATEGRADE
      this.$http(editApi, {
        campusId: this.campusId, // 学习中心ID
        academic: this.academic,
        comments: values.comments,
        courseId: this.courseId,
        score: values.score, //评分
        studentId: this.studentId, //学生ID
        term: this.exam, //学期
        userId: this.userId, //员工ID
        grade: this.classInfo.grade, //
        id: this.gradeId,
      })
        .then(() => {
          this.getDataSource()
          this.getStudentDataSource()
          this.$message.success(this.$t('public.saveSuccess'))
          this.modalVisible = false
          // this.haveCode = false
        })
        .catch(() => {
          this.modalLoading = false
        })
    },

    afterClose() {
      this.form.resetFields()
      this.gradeId = ''
      this.courseId = ''
      this.gradeStatus = false
      this.modalLoading = false
    },

    // 班主任评语
    getFeedback() {
      if (
        this.handleRightsList.includes('班主任反馈') &&
        this.academic &&
        this.exam &&
        this.studentId
      ) {
        this.$http(this.$api.GETFEEDBACKBYSTUDENTID, {
          academic: this.academic,
          term: this.exam,
          studentId: this.studentId,
        }).then((r) => {
          this.feedbackDataSource = r.data
            ? [
                {
                  id: r.data.id,
                  submitStatus: r.data.submitStatus,
                  comments: r.data.comments,
                },
              ]
            : [
                {
                  submitStatus: 0,
                  comments: '',
                },
              ]
        })
      }
    },

    // 编辑反馈
    editFeedback(record) {
      this.feedbackId = record.id
      this.feedbackModalVisible = true
      this.$nextTick().then(() => {
        this.feedbackForm.setFieldsValue({
          comments: record.comments,
        })
      })
    },

    feedbackOk() {
      this.feedbackForm.validateFields((err, values) => {
        if (!err) {
          this.handleSaveFeedback(values)
        }
      })
    },

    handleSaveFeedback(values) {
      this.feedbackModalLoading = true
      const editApi =
        this.feedbackDataSource[0].submitStatus !== 0
          ? this.$api.REEDITFEEDBACK
          : this.$api.UPDATEFEEDBACK
      this.$http(editApi, {
        campusId: this.campusId, // 学习中心ID
        academic: this.academic,
        comments: values.comments,
        studentId: this.studentId, //学生ID
        term: this.exam, //学期
        userId: this.userId, //员工ID
        grade: this.classInfo.grade,
        id: this.feedbackId,
      })
        .then(() => {
          this.getFeedback()
          this.getStudentDataSource()
          this.$message.success(this.$t('public.saveSuccess'))
          this.feedbackModalVisible = false
        })
        .catch(() => {
          this.feedbackModalLoading = false
        })
    },

    feedbackAfterClose() {
      this.feedbackForm.resetFields()
      this.feedbackId = ''
      this.feedbackModalLoading = false
    },
    //学号排序
    sorterStudentNo(a, b) {
      return (
        parseInt(a.studentNo.substring(a.studentNo.length - 3)) -
        parseInt(b.studentNo.substring(b.studentNo.length - 3))
      )
    },
    //英文排序
    sorterEnglishName(a, b) {
      return (a.englishName + '').localeCompare(b.englishName + '')
    },
    //中文排序
    sorterName(a, b) {
      return (a.givenName + '').localeCompare(b.givenName + '')
    },
    //获取全部科目-----右侧
    StudentSubjectData(data) {
      this.$http(this.$api.GETSTUDENTSUBJECT, data).then((r) => {
        // if (r.data.length == 0) return false
        this.subjectId = r.data.length > 0 ? r.data[0].id : ''
        this.subjectName = r.data.length > 0 ? r.data[0].name : ''
        this.subjectData = r.data
        if (r.data.length == 0) return false
        let gradeData = {
          studentId: this.studentId,
          courseId: this.subjectId,
          academic: this.academic,
          semester: this.exam,
        }
        this.getGradeData(gradeData)
      })
    },
    //获取科目成绩
    getGradeData(data) {
      this.$http(this.$api.GETSTUDENTGRADE, data).then((r) => {
        // console.log(r.data)
        this.averageData = [r.data.average]
        this.basicData = r.data.basic
        this.quizData = r.data.quiz
      })
    },
  },
}
</script>

<style lang="less" scoped>
@import '../../style/variable.less';

.grade-class-student {
  padding-top: 0;
  padding-bottom: 0;
  min-height: calc(~'100% - @{pageHeaderHeight}');
  display: flex;
  @timetableTypeWidth: 420px;
  .student-list {
    padding: 15px 0;
    margin-bottom: -30px;
    width: @timetableTypeWidth;
    padding-right: 10px;
    border-right: 1px solid @lineColor;
    .class-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
      .class-title {
        font-size: @titleFontSize;
        .back {
          font-size: 24px;
          cursor: pointer;
        }
      }
    }
  }
  .student-grade {
    padding: 15px 0 0;
    width: calc(~'100% - @{timetableTypeWidth}');
    // padding-left: 10px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    .search-wrap {
      padding-left: 20px;
      border-bottom: 1px solid #e1e6eb;
    }
    .grade-title {
      font-size: @titleFontSize;
      font-weight: bold;
    }

    .cover-header {
      border: 1px solid @lineColor;
      border-bottom: 0;
      background-color: @backColor;
      height: 8px;
      margin: 10px 10px 0;
    }

    .cover-content {
      flex-grow: 1;
      // border: 1px solid @lineColor;
      // padding: 20px;
      .serContent {
        padding: 20px;
        width: 80%;
        float: left;
        .table-title {
          font-size: @titleFontSize;
          margin-bottom: 20px;
        }
        .title {
          font-size: 16px;
          height: 60px;
          line-height: 60px;
          font-weight: 500;
        }
        .student-name {
          font-weight: bold;
        }
      }
      .serContent:last-child {
        width: 20%;
        border-left: 1px solid #e1e6eb;
        /deep/ .ant-table-thead {
          /deep/ .ant-table-row-cell-last {
            background-color: #fff;
            font-size: 16px;
            font-weight: bold;
          }
        }
      }
    }
  }
  .grade-status {
    color: @themeColor;
  }

  .table-list-title {
    font-size: @titleFontSize;
    margin: 25px 0 10px;
  }
}
</style>

<style lang="less">
@import '../../style/variable.less';

.grade-class-student {
  .subject-font {
    font-size: @titleFontSize;
  }
  .selected-row {
    background-color: @selectBackColor;
    &:hover:not(.ant-table-expanded-row) > td {
      background-color: @selectBackColor;
    }
  }
}
</style>
